var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaticTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281 153.333V149.167C281 137.667 271.667 128.333 260.167 128.333C248.667 128.333 239.333 137.667 239.333 149.167V153.333C234.75 153.333 231 157.083 231 161.667V195C231 199.583 234.75 203.333 239.333 203.333H281C285.583 203.333 289.333 199.583 289.333 195V161.667C289.333 157.083 285.583 153.333 281 153.333ZM272.667 153.333H247.667V149.167C247.667 142.25 253.25 136.667 260.167 136.667C267.083 136.667 272.667 142.25 272.667 149.167V153.333ZM214.333 170H206V136.667H224.833C227.167 130.083 231.333 124.167 236.75 120H206V86.6666H256V112.083C257.417 111.917 258.75 111.667 260.167 111.667C264.583 111.667 268.75 112.5 272.667 113.833V69.9999C272.667 60.7499 265.25 53.3333 256 53.3333H139.333C130.167 53.3333 122.667 60.7499 122.667 69.9999V170C122.667 179.25 130.167 186.667 139.333 186.667H214.333V170ZM189.333 170H139.333V136.667H189.333V170ZM189.333 120H139.333V86.6666H189.333V120Z",
    fill: "var(--card-thumbnail-fg)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3405_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(24 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3405_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(366 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3405_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(372 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3405_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(320 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3405_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(326 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticTable);
export default __webpack_public_path__ + "static/media/static-table.651c1812ad857ee0f1edb3d54ca1ecc2.svg";
export { ForwardRef as ReactComponent };